import React from "react";
import { getDiffInMinutesWithTerminalTime } from "../../../../utils/utils";
import PickupNumberRefreshed from "./PickupNumberCell";
import {
  PICKUP_STATUS,
} from "../../../constants";
import { getPickupStatus } from "../../../utils/pickupStatusTypeIcon";

class PickupNumber extends React.Component {
  constructor(props) {
    super(props);
    const pickupStatus = getPickupStatus(
      props.data,
      props.context.terminalOffset
    );
    this.state = {
      timeDiff: this.getTimeDiff(pickupStatus),
      pickupStatus
    };
  }

  getTimeDiff = (pickupStatus) => {
    return pickupStatus === PICKUP_STATUS.newPickup ? getDiffInMinutesWithTerminalTime(
        this.props.data.createdDateTime,
        this.props.context.terminalOffset
      ) : null
  }

  refresh = (props) => {
    const pickupStatus = getPickupStatus(props.data, props.context.terminalOffset)
    this.setState({
      timeDiff: this.getTimeDiff(pickupStatus),
      pickupStatus: pickupStatus,
    });
    return true;
  };

  shouldComponentUpdate(nextProps, nextState) {
    /* Adding this condition here to show new pickup icon for 10 min , 
    after 10 min it will convert to unassign pickup icon then we will rerender component based on props */
    return this.state.pickupStatus !== nextState.pickupStatus || this.state.timeDiff !== nextState.timeDiff
  }

  getTitle = (value) => {
    switch (value) {
      case PICKUP_STATUS.newPickup:
        return `Created ${this.state.timeDiff} min(s) ago`;

      case PICKUP_STATUS.completed:
        return "Completed Pickup";

      case PICKUP_STATUS.voided:
        return "Voided Pickup";

      case PICKUP_STATUS.unacknowledged:
        return "Unacknowledged Pickup";

      case PICKUP_STATUS.future:
        return "Future Pickup";

      case PICKUP_STATUS.notCompleted:
        return "Not Completed Pickup";

      case PICKUP_STATUS.missed:
        return "Missed Pickup";

      case PICKUP_STATUS.dailyPickup:
        return "Daily Pickup";

      case PICKUP_STATUS.unassigned:
        return "Unassigned Pickup";

      default:
        return null;
    }
  };

  render() {
    return (
      <PickupNumberRefreshed
        getTitle={this.getTitle}
        pickupStatus={this.state.pickupStatus}
        value={this.props.value}
      />
    );
  }
}

export default PickupNumber;
